// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: monitorCrud.js
// Description: This file is responsible for All API call for Monitor
//
// ************************************************************************************************************************************************************
import API from "../../../config/networkInterceptor";
import Moment from "moment";

export function addMonitor(cloud_id, monitor_id, facility, autoLogLevel) {
  let postData;
  if (facility === "") {
    postData = {
      cloud_id: cloud_id,
      monitor_id: monitor_id,
      auto_log_level: parseInt(autoLogLevel) ? autoLogLevel : 0,
    };
  } else {
    postData = {
      cloud_id: cloud_id,
      monitor_id: monitor_id,
      facility_id: facility,
      auto_log_level: parseInt(autoLogLevel) ? autoLogLevel : 0,
    };
  }
  return API.post("v1/monitors", postData);
}

export function editMonitor(monitor_id, facility, id, autoLogLevel) {
  let postData;
  if (facility === "" || !facility) {
    postData = {
      id: id,
      monitor_id: monitor_id,
      auto_log_level: parseInt(autoLogLevel) ? autoLogLevel : 0,
    };
  } else {
    postData = {
      id: id,
      monitor_id: monitor_id,
      facility_id: facility,
      auto_log_level: parseInt(autoLogLevel) ? autoLogLevel : 0,
    };
  }
  return API.put("v1/monitors/" + id, postData);
}

export function getMonitor(count, page, sort_column, sort_order) {
  return API.get(
    "v1/monitors?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order
  );
}

export function getUnassignedMoniters(count, page, sort_column, sort_order) {
  return API.get(
    "v1/monitors/unassigned?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order
  );
}
export function getAssignedMoniters(count, page, sort_column, sort_order) {
  return API.get(
    "v1/monitors/assigned?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order
  );
}
/*
==================================================================================
Created On : 17/10/2023
Purpose: Count API Implementation for Monitors count
==================================================================================
*/
export function getMonitersCount(menutype) {
  return API.get("v1/monitors/menu/count/" + menutype);
}
export function getMonitorsById(id, count, page, sort_column, sort_order) {
  return API.get(
    "v1/facilities/" +
      id +
      "/monitors?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order
  );
}

export function getOneMonitor(id) {
  return API.get("v1/monitors/" + id);
}

export function getMonitorDetails(id) {
  return API.get("v1/monitors/" + id + "/audio");
}

export function getMonitorDetailsLog(id) {
  return API.get("v1/monitors/" + id + "/log");
}

export function getSignedUrl(id) {
  return API.get("v1/files/" + id);
}

export function getSignedUrlLog(id) {
  return API.get("v1/files/" + id);
}

export function requestAudio(id) {
  return API.put("v1/monitors/" + id + "/audio");
}

export function requestLog(id) {
  return API.put("v1/monitors/" + id + "/log");
}

export function checkStatus(id) {
  return API.get("v1/monitors/" + id + "/channels/status");
}
/*
==================================================================================
Created On : 9/11/2023
Purpose: Search monitors API Implementation
==================================================================================
*/
export function searchMonitors({
  searchValue,
  facilityId,
  count,
  page,
  sort_column,
  sort_order,
}) {
  return API.post(
    `v1/monitors/search?count=` +
      count +
      `&page=` +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order,
    {
      searchValue,
      facilityId: facilityId,
    }
  );
}

export function getCloudIdLog(values, id, count, page, sort_order) {
  return API.post(
    "v1/monitors/" +
      id +
      "/activities/search?count=" +
      count +
      "&page=" +
      page +
      "&sort_order=" +
      sort_order,
    values
  );
}

export function getMonitorIdLog(
  id,
  from_time,
  to_time,
  time_span,
  count,
  page,
  sort_order
) {
  let fromTime = Moment(from_time.setHours(0, 0, 0)).format();
  let toTime = Moment(to_time.setHours(23, 59, 59)).format();
  return API.get(
    "v1/monitors/" +
      id +
      "/log/" +
      time_span +
      "/" +
      fromTime +
      "/" +
      toTime +
      "?count=" +
      count +
      "&page=" +
      page +
      "&sort_order=" +
      sort_order
  );
}

export function getDeletedMonitors(count, page, sort_column, sort_order) {
  return API.post(
    "v1/monitors/deleted?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order
  );
}

/*
==================================================================================
Created On : 10/11/2023
Purpose: Audio List API Implementation
==================================================================================
*/
export function getAudioList(id, from_time, to_time, count, page) {
  let fromTime = Moment(from_time).format("yyyy-MM-DD");
  let toTime = Moment(to_time).format("yyyy-MM-DD");
  return API.get(
    "v1/monitors/" +
      id +
      "/audiolist" +
      "/" +
      fromTime +
      "/" +
      toTime +
      "?count=" +
      count +
      "&page=" +
      page
  );
}
/*
==================================================================================
Created On : 01/01/2024
Purpose: delete API Implementation for Audio
==================================================================================
*/

export function deleteAudio(from_time, to_time, id, checkedArray, skipedArray) {
  let fromTime = Moment(from_time).format("yyyy-MM-DD");
  let toTime = Moment(to_time).format("yyyy-MM-DD");
  return API.delete(`v1/files/multiple/`, {
    data: {
      time_from: fromTime,
      time_to: toTime,
      monitor_id: id,
      correlation_ids: checkedArray,
      skippedcorrelation_ids: skipedArray,
    },
  });
}

/*
==================================================================================
Created On : 01/01/2024
Purpose: delete API Implementation for Monitor
==================================================================================
*/

export function deleteMonitor(
  monitor_menu,
  forceDelete,
  monitor_ids,
  skippedmonitor_ids
) {
  return API.delete(`v1/monitors/multiple/delete`, {
    data: {
      monitor_menu: monitor_menu,
      forceDelete: forceDelete,
      monitor_ids: monitor_ids,
      skippedmonitor_ids: skippedmonitor_ids,
    },
  });
}
export function deleteSearchMonitor(
  monitor_menu,
  forceDelete,
  searchValue,
  monitor_ids,
  skippedmonitor_ids
) {
  return API.delete(`v1/monitors/multiple/delete/search`, {
    data: {
      monitor_menu: monitor_menu,
      forceDelete: forceDelete,
      searchValue: searchValue,
      monitor_ids: monitor_ids,
      skippedmonitor_ids: skippedmonitor_ids,
    },
  });
}
export function deleteAssociateMonitor(
  monitor_menu,
  forceDelete,
  facility_id,
  monitor_ids,
  skippedmonitor_ids
) {
  return API.delete(`v1/monitors/multiple/delete`, {
    data: {
      monitor_menu: monitor_menu,
      forceDelete: forceDelete,
      facility_id: facility_id,
      monitor_ids: monitor_ids,
      skippedmonitor_ids: skippedmonitor_ids,
    },
  });
}
export function getAllCloudids(inputValue) {
  const postData = {
    search_cloudId: inputValue,
  };
  return API.post("v1/monitors/cloudids", postData);
}
